import { Component, EventEmitter, Input, OnInit, OnChanges, Output, SimpleChange, ViewChild } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";
import { ActionRow } from "../../../../../models/action-row";
import { Bot } from "../../../../../models/bot";
import { ComponentAction } from "../../../../../models/component-action";
import { ComponentActionControllerService } from "../../../../../services/form-controller/component-action-controller.service";
import { LanguageControllerService } from "../../../../../services/language-controller/language-controller.service";
import { DeterminantControllerService } from "../../../../../services/registration-controller/determinant-controller.service";
import { BotControllerService } from "../../../../../services/role-controller/bot-controller.service";
import { RoleControllerService } from "../../../../../services/role-controller/role-controller.service";
import { Store } from "../../../../../services/store.service";
import { BaseError } from "../../../base-error";
import * as _ from "lodash";
import { BotRoleBotsControllerService } from "src/app/services/form-controller/botrole-bots-controller.service";
import { CdkDragDrop, moveItemInArray } from "@angular/cdk/drag-drop";
import { FormControllerService } from "../../../../../services/form-controller/form-controller.service";
import { EditBotComponent } from "../../edit-bot/edit-bot.component";
import { NewBotComponent } from "../../new-bot.component";
import { RoleBotManageComponent } from "../manage/role-bot-manage.component";
import { TreeNode, FieldSelection } from "../../../../utils/field-tree-picker/field-tree-picker.component";

@Component({
  selector: "bot-triggers",
  templateUrl: "./bot-triggers.component.html",
  providers: [BotControllerService, DeterminantControllerService, RoleControllerService, ComponentActionControllerService, BotRoleBotsControllerService],
})
export class BotTriggersComponent extends BaseError implements OnInit, OnChanges {

  @Input() public stickyScrolling: boolean = false;
  @Input() public showTableheader: boolean = true;
  @Input() public roleId: string;
  @Input() public serviceId: string;
  @Input() public embedded: boolean = true;
  @Input() public contextLabel: string = null;
  @Input() public showSystemBots: boolean = true; // not visible for bot-roles
  @Input() public determinantMapById: { [key: string]: string } = {};
  @Output() public editCancel = new EventEmitter();
  public componentKey: string;
  public componentActionId: string;
  public serviceBots: Bot[] = [];
  public componentAction: ComponentAction = new ComponentAction();
  public topLayer = "list";
  public listToggle: boolean = false;
  @Input() public fieldId: string;
  @Output() public determinantChangedEvent = new EventEmitter();
  public selectedAction: ActionRow;
  public showBotBuilder: boolean = false;
  public showDeterminantBuilder: boolean = false;
  public isNew: boolean = false;
  public tmpAction?: ActionRow;
  /* bots*/
  public showBotAdd: boolean = false;
  public showBotEdit: boolean = false;
  public editBot: Bot;
  public showDrawerHeader: boolean = true;
  public tempDet: any;

  public tabsFields: any[] = [];
  public allComponentsTree: TreeNode[] = [];
  public currentFormTree: TreeNode[] = [];
  public tabPanes: Array<{ key: string; name: string; label: string }> = [];
  public selectedFieldKey: any;

  @ViewChild("editBotComponent") public editBotComponent: EditBotComponent;
  @ViewChild("newBotComponent") public newBotComponent: NewBotComponent;
  @ViewChild(RoleBotManageComponent) public roleBotManageComponent: RoleBotManageComponent;

  constructor(public botService: BotControllerService,
              public toastr: ToastrService,
              public determinantService: DeterminantControllerService,
              public translate: TranslateService,
              languageService: LanguageControllerService,
              private formControllerService: FormControllerService,
              public store: Store, private route: ActivatedRoute, private componentActionControllerService: ComponentActionControllerService,
              private botRoleBotsControllerService: BotRoleBotsControllerService) {
    super(toastr);
    translate.setDefaultLang(store.state.common.lang);
    languageService.getLanguages().subscribe(
      (data) => {
        translate.addLangs(data.map((l) => l.code));
      });
  }

  public ngOnInit() {
    if (this.roleId) {
      this.loadBotRoleBots();
      this.loadServiceBots();
      this.loadTabsFields();
      this.loadAllComponents();
    } else {
      this.route.queryParamMap.subscribe((queryParams) => {
        if (queryParams.get("key")) { this.componentKey = queryParams.get("key"); }
        if (queryParams.get("componentActionId")) { this.componentActionId = queryParams.get("componentActionId"); }
        if (queryParams.get("componentName")) { this.contextLabel = queryParams.get("componentName"); }
        if (this.fieldId) { this.componentKey = this.fieldId; }
        this.route.params.subscribe((params) => {
          this.serviceId = params.serviceId;
          this.store.state.common.serviceId = params.serviceId;
          this.loadFormComponentActions();
          this.loadServiceBots();
          this.loadTabsFields();
          this.loadAllComponents();
          if (!Object.keys(this.determinantMapById).length) {
            this.getServiceDeterminantKeyName();
          }
        });
      });
    }
    console.log(this.roleId, this.componentKey, this.componentActionId, this.fieldId, this.serviceId, this.determinantMapById);
   }

   public ngOnChanges(changes: { [propKey: string]: SimpleChange }) {
     this.ngOnInit();
   }

  public getServiceDeterminantKeyName() {
    this.determinantService.getServiceDeterminantIdAndName(this.serviceId).subscribe(
      (data) => Object.assign(this.determinantMapById, data),
    );
  }

  public hideLines(): void {
        document.querySelectorAll(".flow-line").forEach((l) => {
            l.classList.add("overlap");
        });
    }

    public showLines(): void {
        document.querySelectorAll(".flow-line").forEach((l) => {
            l.classList.remove("overlap");
        });
    }

  private loadFormComponentActions() {
    if (this.componentActionId) {
      this.componentActionControllerService.getById(this.componentActionId).subscribe((data) => {
        this.componentAction = data ? data : new ComponentAction();
      });
    } else if (this.serviceId && this.componentKey) {
      this.componentActionControllerService.getComponentAction(this.serviceId, this.componentKey).subscribe(
        (data) => {
          this.componentAction = data ? data : new ComponentAction();
        },
      );
    } else {
      this.componentAction = new ComponentAction();
    }
  }

  private loadBotRoleBots() {
    if (this.roleId) {
      this.botRoleBotsControllerService.getBotRoleBots(this.roleId).subscribe(
        (data) => {
          this.componentAction = data ? data : new ComponentAction();
          this.editBot = null;
          this.showBotEdit = false;
        },
      );
    } else {
      this.componentAction = new ComponentAction();
    }
  }

  private editActionTmp(action?: ActionRow) {
    if (!action) {
      action = new ActionRow();
    }
    if (!action.bots) {
      action.bots = [];
    }
    this.tmpAction = _.cloneDeep(action);
    this.selectedAction = action;
  }

  public openBotBuilder(action: ActionRow) {
    this.editActionTmp(action);
    this.showBotBuilder = true;
    setTimeout(() => {
      this.openBotModal();
    });
  }

  public openDeterminantModal(action: ActionRow) {
    this.tempDet = null;
    this.showAsFullDrawer();
    this.editActionTmp(action);
    this.showDeterminantBuilder = true;
    setTimeout(() => {
      this.moveDetModal();
    });
  }

  public openBotModal() {
    if (this.showBotBuilder) {
      this.showAsFullDrawer();
    }
  }

  public moveDetModal() {
    if (this.showDeterminantBuilder) {
      this.showAsFullDrawer();
    }
  }

  public showModalHeader(e) {
    console.log(e);
    this.showDrawerHeader = e;
  }

  public cancelEdit() {
    this.closeLayer();
    this.editCancel.emit({cancel: true});
  }

  public showAsFullDrawer() {
    if (!this.embedded) {
      this.hideLines();
    }
    const windowParent = window.parent.document.querySelector(".component-settings")?.querySelector(".formio-dialog-content > div > div");
    if (windowParent) {
      windowParent.querySelectorAll("iframe")?.forEach(iframe => iframe.classList.add("full-drawer"));
      windowParent.querySelector(".page-iframe")?.classList.add("full-drawer-content");
      windowParent.querySelector(":scope > .row:nth-child(1)")?.classList.add("d-none");
      // windowParent.querySelector(":scope > .row:nth-child(2)")?.classList.add("d-none");
      windowParent.querySelector(":scope > .row:nth-child(2)")?.querySelector("#myBuilder").classList.add("m-0");
      windowParent.querySelector(":scope > .row:nth-child(2)")?.querySelector(".tab-pane.active").classList.add("p-0", "m-0");
      // windowParent.querySelector(":scope > .row:last-child")?.classList.add("d-none");
      window.parent.document.querySelector(".component-settings")?.querySelector(".formio-dialog-close")?.classList.add("d-none");
      windowParent.querySelector("#element1")?.querySelector(":scope > .formio-component-tabs")?.querySelector(":scope > .nav-tabs")?.classList.add("d-none");
    }
  }

  public backAsFramedDrawer() {
    if (!this.embedded) {
      this.showLines();
    }
    const windowParent = window.parent.document.querySelector(".component-settings")?.querySelector(".formio-dialog-content > div > div");
    if (windowParent) {
      windowParent.querySelectorAll("iframe")?.forEach(iframe => iframe.classList.remove("full-drawer"));
      windowParent.querySelector(".page-iframe")?.classList.remove("full-drawer-content");
      windowParent.querySelector(":scope > .row:nth-child(1)")?.classList.remove("d-none");
      // windowParent.querySelector(":scope > .row:nth-child(2)")?.classList.remove("d-none");
      windowParent.querySelector(":scope > .row:nth-child(2)")?.querySelector("#myBuilder").classList.remove("m-0");
      windowParent.querySelector(":scope > .row:nth-child(2)")?.querySelector(".tab-pane.active")?.classList.remove("p-0", "m-0");
      // windowParent.querySelector(":scope > .row:last-child")?.classList.remove("d-none");
      window.parent.document.querySelector(".component-settings")?.querySelector(".formio-dialog-close")?.classList.remove("d-none");
      windowParent.querySelector("#element1")?.querySelector(":scope > .formio-component-tabs")?.querySelector(":scope > .nav-tabs")?.classList.remove("d-none");
    }
  }

  public closeLayer() {
    this.showBotBuilder = false;
    this.showDeterminantBuilder = false;
    this.tmpAction = null;
    this.selectedAction = null;
    this.backAsFramedDrawer();
  }

  public setListView(b: boolean) {
    this.listToggle = b;
  }

  public closeEdit() {
    this.store.state.common.determinantSection.topLayer = "list";
    this.store.state.common.determinantSection.determinant = {};
    this.sendMessage();
  }

  public updateDeterminant(event: any) {
    console.log("--- updateDeterminant", event, this.tmpAction);
    if (this.tmpAction && this.tempDet) {
      this.tmpAction.jsonDeterminants = this.tempDet;
      this.saveActionComponent();
    } else {
      this.closeLayer();
    }
  }

  public updateBots(event: any) {
    if (event.bot && event.bot.id) {
      if (event.add) {
        this.tmpAction.bots = [event.bot];
      } else {
        this.tmpAction.bots = this.selectedAction.bots.filter((bot) => bot.id !== event.bot.id);
      }
    }
  }

  private canSaveAction(action) {
    if (action.bots && this.tmpAction.bots.length > 0) {
      return true;
    }
    if (action.jsonDeterminants) {
      let determinantCount = 0;
      const determinants = JSON.parse(action.jsonDeterminants);
      if (Array.isArray(determinants)) {
        for (const determinantItem of determinants) {
          if (determinantItem.items) {
            determinantCount += determinantItem.items.length;
          }
        }
      }
      if (determinantCount > 0) {
        return true;
      }
    }
    return false;
  }

  /**
   * One past the highest sortOrderNumber currently assigned to an action row. Numbering
   * from the array length collides once removeActionRow() has deleted a row without
   * reindexing the survivors (TOBE-17996) - length reflects the post-delete row count,
   * not the highest order value still in use. A missing/null value counts as 0, so an
   * empty action list still starts numbering from 1.
   */
  private nextActionSortOrderNumber(): number {
    return this.componentAction.actions.reduce(
      (max, action) => Math.max(max, action.sortOrderNumber ?? 0), 0) + 1;
  }

  public saveActionComponent() {
    if (this.tmpAction) {
      const index = this.componentAction.actions.indexOf(this.selectedAction);
      if (index === -1) {
        if (this.canSaveAction(this.tmpAction)) {
          this.tmpAction.sortOrderNumber = this.nextActionSortOrderNumber();
          this.componentAction.actions.push(this.tmpAction);
        }
      } else {
        if (this.canSaveAction(this.tmpAction)) {
          this.componentAction.actions[index] = this.tmpAction;
        } else {
          this.componentAction.actions.splice(index, 1);
        }
      }
    }
    this.sendSaveProcessingEvent();
    if (this.roleId) {
      if (this.componentAction.roleId) {
        this.botRoleBotsControllerService.saveBotRoleBots(this.componentAction).subscribe(
          () => {
            this.sendMessage();
            this.loadBotRoleBots();
            this.sendSaveProcessingEvent(false);
          },
        );
      } else {
        this.botRoleBotsControllerService.createBotRoleBots(this.roleId, this.componentAction).subscribe(
          () => {
            this.sendMessage();
            this.loadBotRoleBots();
            this.sendSaveProcessingEvent(false);
          },
        );
      }
    } else {
      if (this.componentActionId) {
        this.componentActionControllerService.save(this.componentActionId, this.componentAction).subscribe(
          (data) => {
            Object.assign(this.componentAction, data);
            this.componentActionId = data.id;
            this.sendMessage();
            this.loadFormComponentActions();
            this.sendSaveProcessingEvent(false);
          },
        );
      } else {
        this.componentActionControllerService.saveComponentAction(this.serviceId, this.componentKey, this.componentAction).subscribe(
          (data) => {
            console.log("--- saveComponentAction", data);
            Object.assign(this.componentAction, data);
            this.componentActionId = data.id;
            this.sendMessage();
            this.loadFormComponentActions();
            this.sendSaveProcessingEvent(false);
          },
        );
      }
    }
  }

  public dropped(event: CdkDragDrop<any[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
      // component logic
      event.container.data.forEach((e, i) => {
        e.sortOrderNumber = i;
      });
      this.saveActionComponent();
    }
  }

  public removeActionRow(i: number) {
    this.componentAction.actions.splice(i, 1);
    this.saveActionComponent();
  }

  public isBotEmpty(bots: Bot[]): boolean {
    if (bots && bots.length > 0) {
      return false;
    } else {
      return true;
    }
  }

  public isDeterminantEmpty(jsonDeterminants: string): boolean {
    if (jsonDeterminants && jsonDeterminants !== '[{"type":"OR","items":[]}]') {
      return false;
    }
    return true;
  }

  public loadServiceBots() {
    if (this.serviceId) {
      this.botService.getAllBots(this.serviceId, this.componentKey, this.showSystemBots).subscribe(
        (data) => {
          data = _.sortBy(data, [(d) => d.name.toLowerCase()], ["asc"]);
          this.serviceBots = data.filter((b) => b.botType === "data")
              .concat(data.filter((b) => b.botType === "internal"))
              .concat(data.filter((b) => b.botType === "document"))
              .concat(data.filter((b) => b.botType === "message"))
              .concat(data.filter((b) => b.botType === "link"))
              .concat(data.filter((b) => b.botType === "system"));
        },
      );
    }
  }

  public addedBot() {
    console.log("--- addedBot");
    this.closeAddEdit();
    this.loadServiceBots();
  }

  public temoupdateDeterminant(eff) {
    console.log("--- temoupdateDeterminant", eff);
    this.tempDet = eff.jsonString;
  }

  public openEditModal(bot): void {
    this.showBotEdit = true;
    this.editBot = bot;
  }

  public openAddModal(): void {
    this.showBotAdd = true;
  }

  public closeAddEdit(): void {
    this.showBotAdd = false;
    this.showBotEdit = false;
  }

  public onDeleteBot(bot: Bot): void {
    this.botService.deleteBot(bot.id).subscribe(
      () => {
        this.serviceBots = this.serviceBots.filter(b => b.id !== bot.id);
        this.toastr.success(this.translate.instant("Bot deleted"));
      },
      (error) => this.showErrorMessage(error),
    );
  }

  private sendMessage(): void {
    const message = {
      key: this.componentKey, count: this.componentAction.actions.length,
      changes: {
        componentActionId: this.componentAction.id, actionRowIds: this.componentAction.actions.map((a) => a.id),
      },
    };
    const messageString: string = JSON.stringify(message);
    window.top.postMessage([{channel: "FormBuilder", message: messageString}], "*");
  }

  private sendSaveProcessingEvent(state = true) {
    if (!state) {
      this.closeLayer();
    }
    window.top.postMessage([{channel: "FormBuilder", message: JSON.stringify({event: "saveProcessing", state})}], "*");
  }

  public toggleParallelRole(actionRow: ActionRow): void {
    if (actionRow.parallel === null) {
      actionRow.parallel = true;
    } else {
      actionRow.parallel = !actionRow.parallel;
    }
    this.saveActionComponent();
  }

  public toggleMandatoryRole(actionRow: ActionRow): void {
    if (actionRow.mandatory === null) {
      actionRow.mandatory = true;
    } else {
      actionRow.mandatory = !actionRow.mandatory;
    }
    this.saveActionComponent();
  }

  public directEditBot(bot) {
    this.botService.getBot(bot.id).subscribe(
      (data) => {
        this.openEditModal(data);
      },
    );
  }

  public loadTabsFields(): void {
    if (!this.serviceId) {
      return;
    }
    this.formControllerService.getServiceFields(this.serviceId, { filterByType: "tabs" }).subscribe(
      (data) => {
        this.tabsFields = data;
      },
      (error) => this.showErrorMessageWithTitle("Error when loading tabs fields", error),
    );
  }

  public isTabNavigationAction(action: ActionRow): boolean {
    return action.bots?.some(b =>
      b.shortName === "goToNextPage" ||
      b.shortName === "goToPreviousPage" ||
      b.shortName === "validateCurrentTab"
    ) || false;
  }

  public getTargetTabName(action: ActionRow): string {
    if (!action.targetTabComponentKey) {
      return null;
    }
    const tab = this.tabsFields.find(t => t.key === action.targetTabComponentKey);
    return tab ? (tab.name || tab.key) : action.targetTabComponentKey;
  }

  public clearTargetTab(action: ActionRow): void {
    action.targetTabComponentKey = null;
    this.tmpAction = null;
    this.selectedAction = null;
    this.saveActionComponent();
  }

  public loadAllComponents(): void {
    if (!this.serviceId) {
      return;
    }
    this.formControllerService.getServiceFieldsWithComponentHierarchy(this.serviceId).subscribe(
      (data) => {
        this.allComponentsTree = data || [];
        this.currentFormTree = this.computeCurrentFormTree();
        this.tabPanes = this.computeTabPanes();
      },
      (error) => this.showErrorMessageWithTitle("Error when loading all form fields", error),
    );
  }

  private computeCurrentFormTree(): TreeNode[] {
    if (!this.componentKey || !this.allComponentsTree.length) {
      return this.allComponentsTree;
    }
    for (const form of this.allComponentsTree) {
      if (this.subtreeContainsKey(form, this.componentKey)) {
        return [form];
      }
    }
    return this.allComponentsTree;
  }

  private subtreeContainsKey(node: TreeNode, key: string): boolean {
    if (node.key === key) { return true; }
    if (node.components && node.components.length) {
      for (const child of node.components) {
        if (this.subtreeContainsKey(child, key)) { return true; }
      }
    }
    return false;
  }

  public onTargetElementChange(action: ActionRow, evt: FieldSelection | null): void {
    action.targetElementKey = evt ? evt.key : null;
    this.tmpAction = null;
    this.selectedAction = null;
    this.saveActionComponent();
  }

  public onMultipleFieldChange(action: ActionRow, evt: FieldSelection | null): void {
    action.multipleFieldKey = evt ? evt.key : null;
    this.tmpAction = null;
    this.selectedAction = null;
    this.saveActionComponent();
  }

  public isScrollToElementAction(action: ActionRow): boolean {
    return action.bots?.some(b => b.shortName === "scrollToElement") || false;
  }

  public isGoToTabAction(action: ActionRow): boolean {
    return action.bots?.some((b) => b.shortName === "goToTab") || false;
  }

  /**
   * Destination candidates for goToTab: the direct children (panes) of every
   * type === "tabs" container inside the button's own form tree. Pane keys are
   * what the runtime script resolves via tabItemComponents.
   */
  public computeTabPanes(): Array<{ key: string; name: string; label: string }> {
    const containers: TreeNode[] = [];
    const findContainers = (nodes: TreeNode[]) => {
      for (const n of nodes || []) {
        if (n.type === "tabs") { containers.push(n); }
        if (n.components?.length) { findContainers(n.components); }
      }
    };
    findContainers(this.currentFormTree);
    const panes: Array<{ key: string; name: string; label: string }> = [];
    for (const container of containers) {
      for (const pane of container.components || []) {
        const name = pane.name || pane.key;
        panes.push({
          key: pane.key,
          name,
          label: containers.length > 1 ? `${container.name || container.key} › ${name}` : name,
        });
      }
    }
    return panes;
  }

  public getDestinationTabName(action: ActionRow): string | null {
    if (!action.destinationTabKey) { return null; }
    const pane = this.tabPanes.find((p) => p.key === action.destinationTabKey);
    return pane ? pane.label : action.destinationTabKey;
  }

  public onDestinationTabChange(action: ActionRow, key: string | null): void {
    action.destinationTabKey = key;
    this.tmpAction = null;
    this.selectedAction = null;
    this.saveActionComponent();
  }

  /**
   * True when this action carries the system bot whose shortName identifies the
   * 'Download file' system action. The picker (media-picker) is shown for these
   * rows so the admin can pick the MediaFile to download.
   */
  public isDownloadFileAction(action: ActionRow): boolean {
    return action.bots?.some(b => b.shortName === "downloadFile") || false;
  }

  /**
   * Tracks which ActionRow currently has the media-picker open. Only one picker is
   * visible at a time. Set by the button click in the template; cleared by the
   * picker's (selected) and (cancelled) events.
   */
  public mediaPickerOpenFor: ActionRow = null;

  public openMediaPicker(action: ActionRow): void {
    this.mediaPickerOpenFor = action;
    setTimeout(() => {
      if (this.mediaPickerOpenFor) {
        this.showAsFullDrawer();
      }
    });
  }

  public closeMediaPicker(): void {
    this.mediaPickerOpenFor = null;
    this.backAsFramedDrawer();
  }

  /**
   * Picker selection handler: persist both the id (the runtime resolves files by
   * id, invariant I1) and the filename (denormalised label used by the chip).
   */
  public onMediaFileSelected(action: ActionRow, file: { id: string; name: string }): void {
    action.selectedMediaFileId = file ? file.id : null;
    action.selectedMediaFileName = file ? file.name : null;
    this.mediaPickerOpenFor = null;
    this.tmpAction = null;
    this.selectedAction = null;
    this.backAsFramedDrawer();
    this.saveActionComponent();
  }

  public clearSelectedMediaFile(action: ActionRow): void {
    this.onMediaFileSelected(action, null);
  }

  public getTargetElementName(action: ActionRow): string | null {
    if (!action.targetElementKey) { return null; }
    return this.resolveBreadcrumb(action.targetElementKey) || action.targetElementKey;
  }

  public getTargetElementLeafName(action: ActionRow): string | null {
    if (!action.targetElementKey) { return null; }
    return this.resolveLeafName(action.targetElementKey) || action.targetElementKey;
  }

  public getMultipleFieldName(action: ActionRow): string | null {
    if (!action.multipleFieldKey) { return null; }
    return this.resolveBreadcrumb(action.multipleFieldKey) || action.multipleFieldKey;
  }

  public getMultipleFieldLeafName(action: ActionRow): string | null {
    if (!action.multipleFieldKey) { return null; }
    return this.resolveLeafName(action.multipleFieldKey) || action.multipleFieldKey;
  }

  public toggleMultipleRole(actionRow: ActionRow): void {
    if (actionRow.multipleBot === null) {
      actionRow.multipleBot = true;
    } else {
      actionRow.multipleBot = !actionRow.multipleBot;
    }
    this.saveActionComponent();
  }

  public saveEditBot(): void {
    if (this.editBotComponent) {
      this.editBotComponent.save();
    }
  }

  public saveNewBot(): void {
    if (this.roleBotManageComponent) {
      this.roleBotManageComponent.addNewBot();
    }
  }

  public onEditBotDrawerScroll = _.throttle((): void => {
    if (this.editBotComponent) {
      this.editBotComponent.updateMappingLines();
    }
  }, 100);

  private resolveBreadcrumb(key: string): string | null {
    return this.findInTree(this.allComponentsTree, key, []);
  }

  private findInTree(nodes: TreeNode[], key: string, trail: string[]): string | null {
    for (const n of nodes) {
      const next = [...trail, n.name || n.key];
      if (n.key === key) { return next.join(" › "); }
      if (n.components && n.components.length) {
        const found = this.findInTree(n.components, key, next);
        if (found) { return found; }
      }
    }
    return null;
  }

  private resolveLeafName(key: string): string | null {
    return this.findLeafName(this.allComponentsTree, key);
  }

  private findLeafName(nodes: TreeNode[], key: string): string | null {
    for (const n of nodes) {
      if (n.key === key) { return n.name || n.key; }
      if (n.components && n.components.length) {
        const found = this.findLeafName(n.components, key);
        if (found) { return found; }
      }
    }
    return null;
  }

}
